import { EventName } from './EventName'

// We list all of the properties of events that we log
export interface IEventProperties {
  // Indicates an event is exportable for GDPR
  isExportable?: boolean
}

export const eventProperties: { [key in EventName]?: IEventProperties } = {
  'SettingsButtonClicked': { isExportable: true },
  'FeedbackButtonClicked': { isExportable: true },
  'OpenInAppClicked': { isExportable: true },
  'SDKTelemetryEvent': { isExportable: false }, // Not exporting these one, as they are exported from the SDK
  'NewShoreLineFeedUser': { isExportable: false },
  'NewONEcosytemShoreLineFeedUser': { isExportable: false },
  'AppBootStarted': { isExportable: false },
}
